import { AppState } from "..";
import { BillsbyAdminAction } from "../models/BillsbyAdminAction";
import { SET_LOGIN_FIELD, LOGIN_USER_SUCCESS, LOGIN_USER_REQUEST, LOGIN_USER_FAILURE, VALIDATE_LOGIN_FIELDS, SET_SIX_DIGITS_2FA_PART1, SET_SIX_DIGITS_2FA_PART2 } from "../actions/loginActions";
import { EMAIL_REGEX } from "../utils/constants";
import counterpart from "counterpart";

interface IErrorLogin {
  email?: string,
  password?: string
}

export interface ILoginReducerState {
  email: string,
  password: string,
  rememberUser: boolean,
  errors: IErrorLogin,
  sixDigits2faPart1: string,
  sixDigits2faPart2: string,
  isLoginRequest: boolean,
  isLoginSuccess: boolean,
  isLoginError: boolean,
}

const initialState: ILoginReducerState = {
  email: '',
  password: '',
  rememberUser: true,
  errors: {},
  sixDigits2faPart1: "",
  sixDigits2faPart2: "",
  isLoginRequest: false,
  isLoginSuccess: false,
  isLoginError: false,
}

const validateLoginFields = (state: ILoginReducerState) => {
  const { email, password } = state;
  const errors = {} as IErrorLogin;

  if(!email) {
    errors.email = counterpart("LOGIN_EMPTY_EMAIL");
  }
  if(!password) {
    errors.password = counterpart("LOGIN_EMPTY_PASSWORD");
  }

  return errors;
}

export default function loginReducer(state: ILoginReducerState = initialState, action: BillsbyAdminAction, store: AppState) {
  switch (action.type) {
    case SET_LOGIN_FIELD:
      return { ...state, [action.fieldName]: action.fieldValue }
    case VALIDATE_LOGIN_FIELDS:
      return { ...state, errors: validateLoginFields(state) }
    case LOGIN_USER_REQUEST:
      return { ...state, isLoginRequest: true, isLoginSuccess: false, isLoginError: false }
    case LOGIN_USER_SUCCESS:
        return { ...state, isLoginRequest: false, isLoginSuccess: true, isLoginError: false }
    case LOGIN_USER_FAILURE: {
      const beErrors: { data: { errorCode: string, errorMessage: string }} = action.error;
      let errors = {} as IErrorLogin;
      if(beErrors.data && beErrors.data.errorCode && beErrors.data.errorCode.toLowerCase().includes("email")) {
        errors.email = beErrors.data.errorMessage;
      } else if(beErrors.data && beErrors.data.errorCode) {
        errors.password = beErrors.data.errorMessage;
      }
      return { ...state, isLoginRequest: false, isLoginSuccess: false, isLoginError: true, errors }
    }
    case SET_SIX_DIGITS_2FA_PART1:
      return { ...state, sixDigits2faPart1: action.payload }
    case SET_SIX_DIGITS_2FA_PART2:
      return { ...state, sixDigits2faPart2: action.payload }
    default:
      return state;
  }
}